import { AxiosInstance } from "axios";
import useAuthenticatedFetch from "../useAuthenticatedFetch";
import {
  ResponseCenterAlarmCodeResponse,
  ResponseCenterAlarmCodeDetails,
} from "./types";

const useResponseCenterAlarmCodes = (id: string | number) =>
  useAuthenticatedFetch<ResponseCenterAlarmCodeResponse[]>(
    `/api/v2/responsecenters/${id}/alarmcodes`,
  );

const getResponseCenterAlarmCodes = async (
  id: string | number,
  authenticatedRequest: AxiosInstance,
) =>
  authenticatedRequest.get<ResponseCenterAlarmCodeResponse[]>(
    `/api/v2/responsecenters/${id}/alarmcodes`,
  );

const useResponseCenterAlarmCode = (
  responseCenterId: string | number,
  alarmCodeId: string | number,
) =>
  useAuthenticatedFetch<ResponseCenterAlarmCodeDetails>(
    `/api/v2/responsecenters/${responseCenterId}/alarmcodes/${alarmCodeId}`,
  );

const createAlarmCode = async (
  id: string | number,
  params: ResponseCenterAlarmCodeDetails,
  authenticatedRequest: AxiosInstance,
) => {
  const requestData = JSON.stringify(params);

  return authenticatedRequest.post<{}>(
    `/api/v2/responsecenters/${id}/alarmcodes`,
    requestData,
    { headers: { "Content-Type": "application/json" } },
  );
};

const updateAlarmCode = async (
  responseCenterId: string | number,
  alarmCodeId: string | number,
  params: ResponseCenterAlarmCodeDetails,
  authenticatedRequest: AxiosInstance,
) => {
  const requestData = JSON.stringify(params);

  return authenticatedRequest.put<{}>(
    `/api/v2/responsecenters/${responseCenterId}/alarmcodes/${alarmCodeId}`,
    requestData,
    { headers: { "Content-Type": "application/json" } },
  );
};

const deleteAlarmCode = async (
  responseCenterId: string | number,
  alarmCodeId: string | number,
  authenticatedRequest: AxiosInstance,
) =>
  authenticatedRequest.delete(
    `/api/v2/responsecenters/${responseCenterId}/alarmcodes/${alarmCodeId}`,
  );

export {
  useResponseCenterAlarmCodes,
  getResponseCenterAlarmCodes,
  useResponseCenterAlarmCode,
  createAlarmCode,
  updateAlarmCode,
  deleteAlarmCode,
};
